import React, { useState } from 'react';
import { Brikk } from 'components/Brikk';
import farmersMarket from 'assets/media/farmers-market.jpg';
import Draggable from 'components/drag-and-drop/Draggable';
import { NewPageButton } from 'components/form-elements/buttons/NewPageButton';
import { FarmersMarketIcon } from 'assets/icons/brikks/FarmersMarketIcon';
import { LinkBrikkContent } from 'components/brikks/sub-components/LinkBrikkContent';
import { CircularImage } from 'components/brikks/sub-components/CircularImage';
import { BrikkInfoModal } from 'components/modals/BrikkInfoModal';
import { InfoButton } from 'components/form-elements/buttons/InfoButton';

export const FarmersMarket = ({ position, status, code, name }) => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const handleInfoModal = (e) => {
    e.stopPropagation();
    setIsInfoModalOpen(!isInfoModalOpen);
  };

  return (
    <>
      <Draggable position={position}>
        <Brikk
          brikkKey={code}
          name={name}
          status={status}
        >
          <Brikk.Header
            icon={<FarmersMarketIcon />}
            heading="Farmers Market"
            brikkKey={code}
            status={status}
          />

          <Brikk.Content>
            <CircularImage
              src={farmersMarket}
              alt="Farmers Market"
            />

            <LinkBrikkContent link="hushallningssallskapet.se" />
          </Brikk.Content>

          <Brikk.Button>
            <NewPageButton
              label="Farmers Market Link"
              to="https://hushallningssallskapet.se/"
              brikkNameIntl="Farmers market"
            />
            <InfoButton
              showModal={isInfoModalOpen}
              onClick={handleInfoModal}
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>

      <BrikkInfoModal
        title="Farmers Market info"
        // info={info}
        showModal={isInfoModalOpen}
        onClick={() => setIsInfoModalOpen(!isInfoModalOpen)}
      />
    </>
  );
};
